<div class="flex items-center gap-10 mt-20">
  <tandem-button *ngIf="displayButton" variant="circle" icon="plus" theme="none" [onClick]="emit.bind(this)">add new</tandem-button>
  <h4 *ngIf="displayTotal" class="cols-4 font-bold">Total: {{total | currency}}</h4>
</div>
